<script>
export default {
  name: "mission-values",
};
</script>


<template>
  <section class="mission-values" id="mission-values">
    <div class="container">
      <header>
        <h2>Missão e valores</h2>
      </header>
      <div class="row">
        <div class="col-lg-3 col-md-6">
          <div class="box">
            <img src="@/assets/images/restoque/m1.svg" alt="" />
            <h3>integridade</h3>
            <p>Agir com ética e compromisso com as leis e normas da empresa.</p>
          </div>
        </div>
        <div class="col-lg-3 col-md-6">
          <div class="box">
            <img src="@/assets/images/restoque/m2.svg" alt="" />
            <h3>organização</h3>
            <p>
              Atuar para ter o ambiente de trabalho e recursos da empresa
              organizados, limpos e preservados.
            </p>
          </div>
        </div>
        <div class="col-lg-3 col-md-6">
          <div class="box">
            <img src="@/assets/images/restoque/m3.svg" alt="" />
            <h3>austeridade</h3>
            <p>
              Fazer uso racional dos recursos da empresa e ter foco no que
              agrega valor, impedindo desperdícios e burocracia.
            </p>
          </div>
        </div>
        <div class="col-lg-3 col-md-6">
          <div class="box">
            <img src="@/assets/images/restoque/m4.svg" alt="" />
            <h3>inovação</h3>
            <p>
              Temos que pesquisar, implementar novas tendências, novas
              tecnologias, novos processos e meios inovadores.
            </p>
          </div>
        </div>
        <div class="col-lg-3 col-md-6">
          <div class="box">
            <img src="@/assets/images/restoque/m5.svg" alt="" />
            <h3>criatividade</h3>
            <p>
              Buscar a originalidade, trazer novas soluções para todas as
              iniciativas, processos e produtos.
            </p>
          </div>
        </div>
        <div class="col-lg-3 col-md-6">
          <div class="box">
            <img src="@/assets/images/restoque/m6.svg" alt="" />
            <h3>empenho</h3>
            <p>
              Entender que os negócios impõem constantes desafios e exigem
              determinação e energia para superá-los.
            </p>
          </div>
        </div>
        <div class="col-lg-3 col-md-6">
          <div class="box">
            <img src="@/assets/images/restoque/m7.svg" alt="" />
            <h3>transparência</h3>
            <p>
              Agir e se comunicar com a verdade, sem subterfúgios ou
              dissimulações.
            </p>
          </div>
        </div>
        <div class="col-lg-3 col-md-6">
          <div class="box">
            <img src="@/assets/images/restoque/m8.svg" alt="" />
            <h3>controle de gestão</h3>
            <p>
              Gerir e atuar com informações objetivas, análise de dados,
              controles e decisões fundamentadas.
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>


<style scoped lang="scss">
.mission-values {
  margin-top: 11rem;
  h2 {
    text-transform: uppercase;
    margin-bottom: 2rem;
  }
  @include media-breakpoint-down(md) {
    margin-top: 5rem;
    h2 {
      margin-bottom: 1rem;
    }
  }
   @include media-breakpoint-down(sm) {
    margin-top: 3rem;
    h2 {
      margin-bottom: 1rem;
    }
  }
  .row {
    padding: 0px 0.5rem;
    & > div {
      padding: 0px 0.8rem;
      margin-top: 1.5rem;
      @include media-breakpoint-down(sm) {
        margin-top: 1rem;
      }
    }
  }
  .box {
    box-shadow: 0px 3px 10px #00000029;
    border-radius: 5px;
    background-color: #fff;
    padding: 28px 19px;
    min-height: 340px;
    border-top: 3px solid theme-color(primary);
    @include media-breakpoint-down(sm) {
      min-height: auto;
    }
    img {
      height: 50px;
      margin-bottom: 0.6rem;
    }
    h3 {
      font-size: 1.6rem;
      margin: 1rem 0px;
      display: block;
      font-weight: 400;
      text-transform: uppercase;
    }
    p {
      font-size: 1.35rem;
      line-height: calc(1.35rem * 1.3);
      font-weight: 500 !important;
    }
  }
}
</style>
